import React, { useState } from 'react';
import {TagEditor, Loading} from 'ui';
import { useParams, useHistory } from 'react-router-dom';
import { useTag, updateTag, useAuth, upload, useMedia, refreshTagPreview } from 'api';
import { tagTemplates } from 'config/tags';


export default function TagEdit(props) {
  const auth = useAuth();
  const companyId = auth ? auth.company.id : null;
  const {tagId} = useParams();
  const history = useHistory();
  const tag = useTag(companyId, tagId);
  const media = useMedia(auth ? auth.company.id : null);
  const [isLoading, setLoading] = useState(false);
  
  async function save(tpl, files={}) {
    setLoading(true);
    try {
      if(files.background) {
        const url = await upload(companyId, files.background);
        tpl.background = `url(${url})`;
      }
      if(files.logo) {
        const url = await upload(companyId, files.logo);
        tpl.logo = url;
      }
      const html = tagTemplates[tag.variant.id](tpl);
      await updateTag(companyId, tagId, {html, tpl});
      
      refreshTagPreview(companyId, tagId);
      
      history.push(tag.campaignId && tag.campaignId !== "NONE" ? `/campaigns/${tag.campaignId}` : '/tags');
    }
    catch(error) {
      console.log(error);
      setLoading(false);
    }
  }
  
  async function setTypeImage(type="image") {
    await updateTag(companyId, tagId, {type});
    history.push('upload');
  }
  
  if(!tag || isLoading) {
    return <Loading/>;
  }
  
  return (
    <TagEditor tag={tag} media={media} onSave={save} onChangeType={setTypeImage}/>
  );
  
}
